{
	"name": "partnercard",
	"version": "2.1.13",
	"license": "MIT",
	"browserslist": [
		"> 1%",
		"not dead"
	],
	"scripts": {
		"start": "parcel serve ./src/*.html",
		"build": "parcel build ./src/*.html --dist-dir build --no-cache",
		"test": "parcel build ./src/*.html --dist-dir test --no-cache --no-content-hash"
	},
	"staticFiles": {
		"staticPath": "public"
	},
	"devDependencies": {
		"@parcel/optimizer-data-url": "^2.8.0",
		"@parcel/transformer-inline-string": "^2.8.0",
		"@parcel/transformer-sass": "^2.8.0",
		"parcel": "^2.8.0",
		"parcel-reporter-static-files-copy": "^1.5.0",
		"posthtml-doctype": "^1.1.1",
		"posthtml-include": "^1.7.4",
		"process": "^0.11.10",
		"react": "^18.2.0",
		"react-dom": "^18.2.0"
	},
	"dependencies": {
		"iban": "^0.0.14",
		"react-input-mask": "^3.0.0-alpha.2",
		"react-router-dom": "^6.20.0",
		"semantic-ui-css": "^2.5.0",
		"semantic-ui-react": "^2.1.4"
	}
}
